import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'base' },
  {
    path: 'auth',
    loadChildren: () => {
      return import('./auth/auth.routes').then(
        (m) => m.Auth_Routes
      );
    },
  },
  {
    path: 'base',
    loadChildren: () => {
      return import('./base/base.routes').then(
        (m) => m.Base_Routes
      );
    },
  },
  { path: '**', pathMatch: 'full', redirectTo: 'auth' }
];

